module.exports = __webpack_public_path__ + "img/Hermes.42bd6a6f.png";